export default __webpack_public_path__ + "static/media/gie-logo-bg-3.b2b7d678.jpg";